import React, { Fragment, useEffect, useState } from "react";
import { Card, Row, Col, Form} from "react-bootstrap";
import { PhysicianName } from "../Physician/Models/PhysicianCreation";
import { deepCopy } from "../Shared/Utility/DeepCopy";
import { getDateWithOffset } from "../Shared/Utility/GetDateWithOffset";
import SearchPhysicianModel from './Models/SearchPhysicianModel';
interface IProps {
    physicianData: SearchPhysicianModel;
    runValidation: boolean;
    isFormValid: boolean;
    updatePersonalInformation: (name: PhysicianName) => void;
    updatePersonalInformationValidation: (isValid: boolean) => void;
}

export function PersonalInformationCard(props: IProps) {
    const [name, setName] = useState<PhysicianName>(null);

    useEffect(() => {
        if (props.runValidation) validate();
    }, [props.runValidation]);

    useEffect(() => {
        const createPhysicianName = () => {
            var newName = new PhysicianName();
            newName.lastName = props.physicianData.lastName;
            setName(newName);
        }
        createPhysicianName();
    }, []);

    const updateFirstName = (e: React.ChangeEvent<HTMLSelectElement>) => {
        var updatedName = deepCopy(name);
        updatedName.firstName = e.target.value;
        setName(updatedName);
        props.updatePersonalInformation(updatedName);
    }

    const updateMiddleName = (e: React.ChangeEvent<HTMLSelectElement>) => {
        var updatedName = deepCopy(name);
        updatedName.middleName = e.target.value;
        setName(updatedName);
        props.updatePersonalInformation(updatedName);
    }

    const updateSuffix = (e: React.ChangeEvent<HTMLSelectElement>) => {
        var updatedName = deepCopy(name);
        updatedName.suffix = e.target.value;
        setName(updatedName);
        props.updatePersonalInformation(updatedName);
    }
    const updateTitle = (e: React.ChangeEvent<HTMLSelectElement>) => {
        var updatedName = deepCopy(name);
        updatedName.title = e.target.value;
        setName(updatedName);
        props.updatePersonalInformation(updatedName);
    }

    const validate = () => {
        const form = document.getElementById("nameForm") as HTMLFormElement;

        props.updatePersonalInformationValidation(form.checkValidity());
    }

    return (
        <Fragment>
            <Card className="mb-4" border="pp-secondary-grey">
                <Card.Body>
                    <Card.Title className="mb-0 font-weight-bolder">
                        <span className="text-pp-primary">Personal</span>
                    </Card.Title>
                    <Row className="mt-3">
                        <Col xs={12} md={12} lg={12} xl={12}>
                            <Form noValidate id="nameForm" validated={props.isFormValid === false}>
                                <Row noGutters className="align-items-end">
                                    <Col xs={12} md={12} lg={4} xl={4} className="px-2">
                                        <Form.Group controlId="firstNameId">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">First Name<span className="text-pp-primary ml-2">*</span></Form.Label>
                                            <Form.Control required type="input" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {updateFirstName(e)}}></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={12} lg={4} xl={4} className="px-2">
                                        <Form.Group controlId="middleNameId">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Middle Name</Form.Label>
                                            <Form.Control type="input" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {updateMiddleName(e)}}></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={12} lg={4} xl={4} className="px-2">
                                        <Form.Group controlId="lastNameId">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Last Name</Form.Label>
                                            <Form.Control placeholder={props.physicianData.lastName} type="input" disabled></Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row noGutters className="align-items-end">
                                    <Col xs={12} md={12} lg={4} xl={4} className="px-2">
                                        <Form.Group controlId="suffixId">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Suffix</Form.Label>
                                            <Form.Control type="input" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {updateSuffix(e)}}></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={12} lg={4} xl={4} className="px-2">
                                        <Form.Group controlId="titleId">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Title<span className="text-pp-primary ml-2">*</span></Form.Label>
                                            <Form.Control required type="input" onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {updateTitle(e)}}></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={12} lg={2} xl={2} className="px-2">
                                        <Form.Group controlId="dobId">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Date of Birth</Form.Label>
                                            <Form.Control placeholder={getDateWithOffset(props.physicianData.dateOfBirth).toLocaleDateString()} type="input" disabled></Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} md={12} lg={2} xl={2} className="px-2">
                                        <Form.Group controlId="ssn4Id">
                                            <Form.Label className="font-weight-bolder mb-1 pp-font-size-smaller">Last 4 Digits of SSN</Form.Label>
                                            <Form.Control placeholder={props.physicianData.ssn4} type="input" disabled></Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Fragment>
    );
}

export default PersonalInformationCard;
